import { AuthService } from './services/auth/auth.service';
import { UserModeService } from './services/customs/user-mode/user-mode.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'truckit_business_fe';
  isCollapsed = true;
  currentUser: any = null;
  activeMode: 'customer' | 'provider' | null = null;

  readonly aiApiEndpoint = `${environment.aiApiUrl}/assistant/api/provider/query`;
  readonly aiSuggestEndpoint = `${environment.aiApiUrl}/assistant/api/provider/suggest-query`;

  constructor(
    public router: Router,
    private authService: AuthService,
    private userModeService: UserModeService
  ) {
    this.authService.user$.subscribe(user => this.currentUser = user);
    this.userModeService.mode$.subscribe(mode => this.activeMode = mode);
  }

  handleLogout() {
    window.location.href = 'https://truckit.net/logout';
  }

  onQuoteListing(listing: any) {
    // TODO: navigate to quote page or open quote modal
    console.log('Quote requested for listing:', listing);
  }

  onAiChatClose() {}

  onAiChatMaximize() {}

  onNewConversation() {}

  public hiddenSidebarUrls: string[] = [
    '/view/proof-of-delivery/',
    '/access-denied',
  ];

  // URLs for which the header should be hidden
  public hiddenHeaderUrls: string[] = [
    '/view/proof-of-delivery/',
    '/access-denied',
  ];

  // Determine if the header should be hidden based on the current URL
  public isHeaderHidden(): boolean {
    return this.hiddenHeaderUrls.some(prefix => this.router.url.startsWith(prefix));
  }

  public isSidebarHidden(): boolean {
    return this.hiddenSidebarUrls.some(prefix => this.router.url.startsWith(prefix));
  }

  public isFullWidthPage(): boolean {
    const fullWidthPrefixes = ['/broker-manager', '/listings-and-bookings'];
    return fullWidthPrefixes.some(prefix => this.router.url.startsWith(prefix));
  }

  toggleSidebar(collapsed: boolean) {
    this.isCollapsed = collapsed;
  }
}
